import styled from 'styled-components/macro';
import Title from '../Title';
import media from '../../styles/media';
import { fontSize } from '../../styles/mixins';

export const Banner = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const BannerTitle = styled(Title)`
  margin-bottom: 16px;
  ${media.desktop`
  margin-bottom: ${({ subtitle }) => (subtitle ? '13px' : '25px')}  ;
  `}
`;

export const BannerSubtitle = styled.h2`
  ${fontSize(12)};
  color: ${({ theme }) => theme.colorText};
  font-weight: ${({ bold }) => (bold ? `bold` : `normal`)};
  line-height: 1.2;
`;
